import React from 'react';

export default function PrayerFormHeader() {
  return (
    <div className="mb-6">
      <h1 className="text-xl font-semibold text-black dark:text-white mb-2">Share Your Prayer</h1>
      <p className="text-sm text-black dark:text-white leading-relaxed">
        Share your prayer request with our community for support and intercession.
      </p>
    </div>
  );
}
